export default __webpack_public_path__ + "static/media/icn-radio-off.493f2542.svg";